import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    notes: [],
    bookmarks: [],
    reminders: [],
};

const localSlice = createSlice({
    name: 'local',
    initialState,
    reducers: {
        addToLocalList(state, action) {
            const { list, data } = action.payload;
            const newEntries = [{ ...data, id: Date.now() }, ...state[list]];
            state[list] = newEntries;
        },
        removeFromLocalList(state, action) {
            const { list, id } = action.payload;
            const newEntries = state[list].filter((entry) => entry.id !== id);
            state[list] = newEntries;
        },
        updateLocalListItem(state, action) {
            const { list, data } = action.payload;
            const newEntries = state[list].map((entry) => {
                if (entry.id === data.id) {
                    return data;
                }
                return entry;
            });
            state[list] = newEntries;
        },
    },
});

export const { addToLocalList, removeFromLocalList, updateLocalListItem } =
    localSlice.actions;

export default localSlice.reducer;
